/*
 * Project: bellcloud
 * File: packages/protocols/mini/fn_information.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: ClassID.INFORMATION (0x01)에 대한 FunctionID별 파라미터 정의
 */
import type { FunctionParameter } from '../fns';

export const params_information: Record<number, FunctionParameter[]> = {
  0x01: [], // Request instrument information - no parameters
  0x02: [
    {
      name: 'serial_number',
      type: 'au8[]',
      bytes: 20,
      comment: 'Characters, null termination',
      format: 'string',
    },
    {
      name: 'manufacture_date',
      type: 'u16',
      bytes: 2,
      comment: 'The date of production. Days since 2023.01.01',
      format: 'date_from_basedate',
    },
    {
      name: 'hw_version',
      type: 'au8[]',
      bytes: 2,
      comment: '[0]: PCB, [1]: LCD type(0: BlueDP, 1: Lodule)',
      format: 'version',
    },
    {
      name: 'fw_version',
      type: 'au8[]',
      bytes: 3,
      comment: '[0]: major, [1]: minor, [2]: patch',
      format: 'version',
    },
    {
      name: 'equipped_sensor',
      type: 'u8',
      bytes: 1,
      comment: 'See equipped sensor (0~17)',
      format: 'enum_sensors',
    },
    {
      name: 'calibration_due_date',
      type: 's16',
      bytes: 2,
      comment: '0~365 days left, if negative value is arrived, it is overdue',
      format: 'date_with_sign',
    },
    {
      name: 'bump_due_date',
      type: 's16',
      bytes: 2,
      comment: '0~365 days left, if negative value is arrived, it is overdue',
      format: 'date_with_sign',
    },
    {
      name: 'last_calibration_days',
      type: 'u16',
      bytes: 2,
      comment: 'Days since 2023.01.01',
      format: 'date_from_basedate',
    },
    {
      name: 'last_bump_days',
      type: 'u16',
      bytes: 2,
      comment: 'Days since 2023.01.01',
      format: 'date_from_basedate',
    },
    {
      name: 'activation_date_time',
      type: 'u16',
      bytes: 2,
      comment:
        'Days of activation. At the first power-up, it will be record. Days since 2023.01.01',
      format: 'date_from_basedate',
    },
    {
      name: 'decimal_point_and_unit',
      type: 'u8',
      bytes: 1,
      comment: 'Bit 0~3: Decimal point(0~2), Bit 4~7: Unit(see below)',
      format: 'decimal_point_and_unit',
    },
  ],
  0x03: [], // Request BLE info - no parameters
  0x04: [
    {
      name: 'mac_address',
      type: 'au8[]',
      bytes: 18,
      comment: 'MAC address',
      format: 'mac_address',
    },
    {
      name: 'device_name',
      type: 'au8[]',
      bytes: 20,
      comment: 'BELLMINI + SN, refer to serial number. EASYGAS + SN for TechnoControl(ODM)',
      format: 'string',
    },
    {
      name: 'fw_version',
      type: 'au8[]',
      bytes: 3,
      comment: '[0]: major, [1]: minor, [2]: patch',
      format: 'version',
    },
  ],
};
